(() => {
  if (window.__awJudgeMeCustomLoaded) {
    return;
  }

  window.__awJudgeMeCustomLoaded = true;

  const selectors = {
    root: "[data-aw-judge-me-custom]",
    view: "[data-aw-judge-me-view]",
    nativeWriteButton: ".jm-action-buttons__button, .jdgm-write-rev-link, .jdgm-write-rev-link.jdgm-write-rev-link",
  };

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function stripHtml(value) {
    const element = document.createElement("div");
    element.innerHTML = value || "";
    return element.textContent || element.innerText || "";
  }

  function formatDate(value) {
    if (!value) {
      return "";
    }

    const date = new Date(value);

    if (Number.isNaN(date.getTime())) {
      return "";
    }

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}/${month}/${day}`;
  }

  function formatRating(value) {
    const number = Number.parseFloat(value);

    if (Number.isNaN(number)) {
      return "0.0";
    }

    return number.toFixed(1);
  }

  function renderStars(value, className) {
    const rating = Math.min(5, Math.max(0, Number.parseFloat(value) || 0));
    const floor = Math.floor(rating);
    const fraction = rating - floor;
    let fullCount = floor;
    let halfIndex = 0;

    if (fraction >= 0.3 && fraction <= 0.7) {
      halfIndex = floor + 1;
    } else if (fraction > 0.7) {
      fullCount = floor + 1;
    }

    let html = "";

    for (let index = 1; index <= 5; index += 1) {
      const modifier = index <= fullCount ? "--full" : index === halfIndex ? "--half" : "--empty";
      const symbol = index <= fullCount || index === halfIndex ? "★" : "☆";

      html += `<span class="${className} ${className}${modifier}" aria-hidden="true">${symbol}</span>`;
    }

    return html;
  }

  function normalizeLabel(value) {
    return String(value || "")
      .replace(/\s/g, "")
      .replace(/：/g, ":")
      .toLowerCase();
  }

  function getAnswerValue(answer) {
    if (!answer) {
      return "";
    }

    if (Array.isArray(answer.value)) {
      return answer.value.filter(Boolean).join("、");
    }

    if (Array.isArray(answer.answer)) {
      return answer.answer.filter(Boolean).join("、");
    }

    return answer.value || answer.answer || answer.text || "";
  }

  function getReviewMeta(review) {
    const meta = {
      purchaser: "",
      size: "",
      color: "",
    };

    if (Array.isArray(review.cf_answers)) {
      review.cf_answers.forEach((answer) => {
        const label = normalizeLabel(answer.label || answer.question || answer.name || "");
        const value = getAnswerValue(answer);

        if (!value) {
          return;
        }

        if (label.includes("購入者") || label.includes("職種") || label.includes("属性")) {
          meta.purchaser = value;
        } else if (label.includes("サイズ") || label.includes("size")) {
          meta.size = value;
        } else if (label.includes("カラー") || label.includes("color") || label.includes("色")) {
          meta.color = value;
        }
      });
    }

    if (!meta.size && review.product_variant_title) {
      const variantParts = String(review.product_variant_title)
        .split("/")
        .map((part) => part.trim())
        .filter(Boolean);

      if (variantParts.length === 1) {
        meta.size = variantParts[0];
      }

      if (variantParts.length >= 2) {
        meta.size = variantParts[0];
        meta.color = variantParts[1];
      }
    }

    const parts = [];

    if (meta.purchaser) {
      parts.push(`購入者: ${meta.purchaser}`);
    }

    if (meta.size) {
      parts.push(`サイズ: ${meta.size}`);
    }

    if (meta.color) {
      parts.push(`カラー: ${meta.color}`);
    }

    return parts.join(" / ");
  }

  function getWidgetData(productId) {
    const jdgm = window.jdgm;

    if (!jdgm || !jdgm.data || !jdgm.data.reviewWidget) {
      return null;
    }

    return jdgm.data.reviewWidget[productId] || jdgm.data.reviewWidget[String(productId)] || null;
  }

  function getReviewReply(review) {
    const replySource = Object.keys(review || {})
      .filter((key) => /^(reply_content|reply|response|merchant_answer|shop_answer)$/i.test(key))
      .map((key) => review[key])
      .find(Boolean);

    if (!replySource) {
      return null;
    }

    const reply = Array.isArray(replySource) ? replySource[0] : replySource;

    if (typeof reply === "string") {
      const body = stripHtml(reply).trim();
      return body ? { body, date: "" } : null;
    }

    if (typeof reply !== "object") {
      return null;
    }

    const bodySource =
      reply.body ||
      reply.body_html ||
      reply.text ||
      reply.content ||
      reply.message ||
      (typeof reply.reply === "string" ? reply.reply : "");
    const body = stripHtml(bodySource).trim();

    if (!body) {
      return null;
    }

    return {
      body,
      date: formatDate(reply.created_at || reply.updated_at || reply.date),
    };
  }

  function getNativeReplies(root) {
    const native = root.querySelector(selectors.native);

    if (!native) {
      return [];
    }

    return Array.from(
      native.querySelectorAll(".jdgm-rev, .jdgm-rev-widg__review, [data-review-id]")
    ).map((reviewElement) => {
      const replyElement = reviewElement.querySelector(
        ".jdgm-rev__reply-content"
      );

      if (!replyElement) {
        return null;
      }

      const body = stripHtml(replyElement.textContent || "").trim();

      return body ? { body, date: "" } : null;
    });
  }

  function renderReview(review, index, visibleCount, nativeReply) {
    const title = review.title || "";
    const body = review.body || stripHtml(review.body_html || "");
    const date = formatDate(review.created_at);
    const meta = getReviewMeta(review);
    const reply = getReviewReply(review) || nativeReply;
    const hiddenClass = index >= visibleCount ? " is-hidden" : "";

    return `
      <article class="aw-judge-me-custom__item${hiddenClass}" data-aw-judge-me-review-item>
        <div class="aw-judge-me-custom__item-head">
          <div class="aw-judge-me-custom__title-row">
            <div class="aw-judge-me-custom__review-stars" aria-label="${escapeHtml(review.rating)} out of 5 stars">
              ${renderStars(review.rating, "aw-judge-me-custom__star")}
            </div>
            ${title ? `<h3 class="aw-judge-me-custom__title">${escapeHtml(title)}</h3>` : ""}
          </div>
          ${date ? `<p class="aw-judge-me-custom__date">${escapeHtml(date)}</p>` : ""}
        </div>

        ${body ? `<div class="aw-judge-me-custom__body"><p>${escapeHtml(body)}</p></div>` : ""}
        ${meta ? `<p class="aw-judge-me-custom__meta">${escapeHtml(meta)}</p>` : ""}
        ${
          reply
            ? `<div class="aw-judge-me-custom__reply">
                <p class="aw-judge-me-custom__reply-label">ショップからの返信${
                  reply.date ? `（${escapeHtml(reply.date)}）` : ""
                }</p>
                <p class="aw-judge-me-custom__reply-text">${escapeHtml(reply.body)}</p>
              </div>`
            : ""
        }
      </article>
    `;
  }

  function render(root, data, nativeReplies = []) {
    const view = root.querySelector(selectors.view);

    if (!view) {
      return;
    }

    const reviews = Array.isArray(data.reviews) ? data.reviews : [];
    const reviewCount = Number(data.number_of_reviews || reviews.length || 0);
    const averageRating = formatRating(data.average_rating || 0);
    const visibleCount = Math.max(1, Number.parseInt(root.dataset.initialVisibleCount || "2", 10));

    if (!reviews.length) {
      view.innerHTML = `
        <div class="aw-judge-me-custom__empty-wrap">
          <p class="aw-judge-me-custom__empty">レビューはまだありません。</p>

          <button class="aw-judge-me-custom__write-button" type="button" data-aw-judge-me-write>
            レビューを書く
          </button>
        </div>
      `;

      view.hidden = false;
      root.classList.add("is-custom-ready");

      const writeButton = view.querySelector("[data-aw-judge-me-write]");

      if (writeButton) {
        writeButton.addEventListener("click", () => {
          const nativeButton = root.querySelector(selectors.nativeWriteButton);

          if (nativeButton) {
            nativeButton.click();
          }
        });
      }

      return;
    }

    const reviewItems = reviews
      .map((review, index) => renderReview(review, index, visibleCount, nativeReplies[index]))
      .join("");

    const hasMore = reviews.length > visibleCount;

    view.innerHTML = `
      <div class="aw-judge-me-custom__header">
        <div class="aw-judge-me-custom__summary">
          <div class="aw-judge-me-custom__summary-stars" aria-label="${escapeHtml(averageRating)} out of 5 stars">
            ${renderStars(averageRating, "aw-judge-me-custom__star")}
          </div>

          <div class="aw-judge-me-custom__rating-row">
            <span class="aw-judge-me-custom__rating">${escapeHtml(averageRating)}</span>
            <span class="aw-judge-me-custom__count">(${reviewCount}件のレビュー)</span>
          </div>
        </div>

        <button class="aw-judge-me-custom__write-button" type="button" data-aw-judge-me-write>
          レビューを書く
        </button>
      </div>

      <div class="aw-judge-me-custom__list">
        ${reviewItems}
      </div>

      ${
        hasMore
          ? `<div class="aw-judge-me-custom__more-wrap">
              <button class="aw-judge-me-custom__more" type="button" data-aw-judge-me-more>
                すべてのレビューを見る（${reviewCount}）
              </button>
            </div>`
          : ""
      }
    `;

    view.hidden = false;
    root.classList.add("is-custom-ready");

    const writeButton = view.querySelector("[data-aw-judge-me-write]");
    const moreButton = view.querySelector("[data-aw-judge-me-more]");

    if (writeButton) {
      writeButton.addEventListener("click", () => {
        const nativeButton = root.querySelector(selectors.nativeWriteButton);

        if (nativeButton) {
          nativeButton.click();
        }
      });
    }

    if (moreButton) {
      moreButton.addEventListener("click", () => {
        view.querySelectorAll("[data-aw-judge-me-review-item].is-hidden").forEach((item) => {
          item.classList.remove("is-hidden");
        });

        const wrap = moreButton.closest(".aw-judge-me-custom__more-wrap");

        if (wrap) {
          wrap.remove();
        }
      });
    }
  }

  function initRoot(root) {
    if (!root) {
      return;
    }

    const productId = root.dataset.productId;
    const native = root.querySelector(selectors.native);
    let count = 0;
    const maxCount = 40;
    let lastNativeReplySignature = "";

    const renderFromSources = () => {
      const data = getWidgetData(productId);

      if (!data) {
        return false;
      }

      const nativeReplies = getNativeReplies(root);
      const nativeReplySignature = JSON.stringify(nativeReplies);

      if (nativeReplySignature !== lastNativeReplySignature || !root.classList.contains("is-custom-ready")) {
        lastNativeReplySignature = nativeReplySignature;
        render(root, data, nativeReplies);
      }

      return true;
    };

    if (native && window.MutationObserver) {
      const observer = new MutationObserver(() => {
        renderFromSources();
      });

      observer.observe(native, { childList: true, subtree: true });
    }

    function tryRender() {
      count += 1;

      if (renderFromSources()) {
        return;
      }

      if (count < maxCount) {
        window.setTimeout(tryRender, 250);
      }
    }

    tryRender();
  }

  function initAll(container = document) {
    container.querySelectorAll(selectors.root).forEach(initRoot);
  }

  document.addEventListener("shopify:section:load", (event) => {
    initAll(event.target);
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAll(document));
  } else {
    initAll(document);
  }
})();
